import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Phone, Mail, MessageCircle } from 'lucide-react';
import Reveal from './Reveal';
import OptimizedImage from './OptimizedImage';

const ContactDetail: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white" style={{ marginTop: '80px' }}>
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/')}
              className="flex items-center text-pink-500 hover:text-pink-600 transition-colors"
            >
              <ArrowLeft size={20} className="mr-2" />
              戻る
            </button>
            <h1 className="text-xl font-bold" style={{ color: '#e3628d' }}>
              お問い合わせ
            </h1>
            <div className="w-20"></div>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <Reveal className="text-center mb-8" duration={1.2} delay={0.6}>
              <p className="text-gray-600">
                お気軽にご連絡くださいね！<br />
                LINEでは、うのつのぶこAIがすぐに応対します。<br />
                地域の声をお聞かせください。
              </p>
            </Reveal>

            <Reveal className="bg-white rounded-lg shadow p-6 mb-6" duration={1.2} delay={0.9}>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <MessageCircle className="w-5 h-5 mr-3 text-pink-500 mt-1" />
                  <div>
                    <div className="font-semibold text-gray-800">LINE（うのつのぶこAIが応対）</div>
                    <a
                      href="https://line.me/R/ti/p/@296ekiii"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-pink-600 text-sm hover:underline break-all"
                    >
                      https://line.me/R/ti/p/@296ekiii
                    </a>
                  </div>
                </li>
                <li className="flex items-center">
                  <Phone className="w-5 h-5 mr-3 text-pink-500" />
                  <a href="tel:09034733872" className="text-gray-800 hover:underline">090-3473-3872</a>
                </li>
                <li className="flex items-center">
                  <Mail className="w-5 h-5 mr-3 text-pink-500" />
                  <a href="mailto:ns821826hs117@gmail.com" className="text-gray-800 hover:underline">ns821826hs117@gmail.com</a>
                </li>
              </ul>
            </Reveal>

            <Reveal className="bg-white rounded-lg shadow p-6 text-center" duration={1.0} delay={1.2}>
              <div className="mb-3 font-semibold text-gray-800">LINE QRコード</div>
              <OptimizedImage
                src="/line_qr_code.jpg"
                alt="LINE QRコード"
                className="mx-auto h-64 w-auto rounded"
                widths={[320, 480, 640]}
                sizes="(max-width: 640px) 90vw, 480px"
              />
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetail;

